import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { VesTransactionsService, VesTransactionItem } from '../../../services/ves-transactions.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-approve-swap-modal',
  templateUrl: './approve-swap-modal.component.html',
  styleUrls: ['./approve-swap-modal.component.sass'],
})
export class ApproveSwapModalComponent {
  transaction: VesTransactionItem;
  loading = false;

  constructor(
    private vesTransactionsService: VesTransactionsService,
    public dialogRef: MatDialogRef<ApproveSwapModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: VesTransactionItem,
  ) {
    this.transaction = data;
  }

  formatVES(amount: number | null | undefined): string {
    if (amount === null || amount === undefined) return '-';
    return new Intl.NumberFormat('es-VE', {
      style: 'currency',
      currency: 'VES',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  }

  get isRetiroVes(): boolean {
    return this.transaction.type === 'RETIRO_VES';
  }

  approveSwap(): void {
    if (this.loading) return;
    this.loading = true;

    const request$ = this.isRetiroVes
      ? this.vesTransactionsService.approveRetiroVes(this.transaction.id)
      : this.vesTransactionsService.approveSwap(this.transaction.id);

    request$.subscribe({
      next: () => {
        Swal.fire({
          icon: 'success',
          title: this.isRetiroVes ? 'Retiro VES aprobado' : 'Swap aprobado',
          text: 'La transacción ha sido aprobada exitosamente',
          showCancelButton: false,
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#1e5a3f',
        });
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.loading = false;
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: err.message || 'Error al aprobar la transacción',
          showCancelButton: false,
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#1e5a3f',
        });
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
